export const BUTTON_STATUS = Object.freeze({
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  HOVER: 'Hover',
  PRESSED: 'Pressed',
  FOCUS: 'Focus',
});

export const BUTTON_NAME = Object.freeze({
  DELETE: '삭제하기',
  EDIT: '편집하기',
  COMPLETE_EDIT: '편집완료',
});
